import React, {useState, useEffect} from 'react';
import axios from '@app/lib/axios';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import * as Constant from '@app/Constant.js';
import Spinner from '../../../components/Spinner';

import AppVersionLogUpdateForm from './AppVersionLogUpdateForm.js';

const easyFilter = [

    {   
        displayKey: '포함',
        displayName: '키워드 포함',
        test: function(filterValue, cellValue) {
          if (cellValue == null) return false;
          return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {   
        displayKey: '일치',
        displayName: '키워드 일치',
        test: function(filterValue, cellValue) {
          
          return filterValue == cellValue;
        },
    }

]

const listColumn = [
    {
        headerName: "플랫폼",
        field: "platform_name",
        sortable: true,
        width : 100,
        maxWidth : 120,
        filter: "agTextColumnFilter",
        filterParams: {
            filterOptions: easyFilter
        },
        cellRenderer : (param) => {
            var icon = '<span class="ml-2 pl-1 icon-circle-small icon-box-xs text-'+param.data.platform_icon_color+' bg-'+param.data.platform_icon_color+'-light">'+
                   '     <i class="fab '+param.data.platform_icon +'"></i>&nbsp;&nbsp;' +
                   '</span>&nbsp;&nbsp;'+param.value;
            return icon;
        }
    },
    {
        headerName: "배포 날짜",
        field: "deploy_date",
        sortable: true,
        filter: true,
        filter: 'agDateColumnFilter',
        cellClass: "text-center",
        width : 120,
        maxWidth : 140,
        // add extra parameters for the date filter
        filterParams: {
            filterOptions: [
                {   
                    displayKey: '일치',
                    displayName: '날짜 일치',
                    test: function(filterLocalDateAtMidnight, cellValue) {

                        var dateAsString = cellValue;

                        if (dateAsString == null) {
                            return false;
                        }
                        
                        var dateParts = dateAsString.split('-');
                        var day = Number(dateParts[2]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[0]);
                        var cellDate = new Date(year, month, day);


                        return filterLocalDateAtMidnight.getFullYear() == year && 
                            filterLocalDateAtMidnight.getMonth() == month &&
                            filterLocalDateAtMidnight.getDate() == day
                            ;
                    },
                },
            ],
            // provide comparator function
            comparator: function(filterLocalDateAtMidnight, cellValue) {
                var dateAsString = cellValue;

                if (dateAsString == null) {
                    return 0;
                }
                
                var dateParts = dateAsString.split('-');
                var day = Number(dateParts[2]);
                var month = Number(dateParts[1]) - 1;
                var year = Number(dateParts[0]);
                var cellDate = new Date(year, month, day);

                // Now that both parameters are Date objects, we can compare
                if (cellDate < filterLocalDateAtMidnight) {
                    return -1;
                } else if (cellDate > filterLocalDateAtMidnight) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }
      },
     {
        headerName: "버전",
        field: "version",
        sortable: true,
        width : 80,
        maxWidth : 100,
        filter: "agTextColumnFilter",
        cellClass: "text-center",
        filterParams: {
            filterOptions: easyFilter
        },
        cellRenderer : (param) => {
            return param.value + (param.data.code ? '(' + param.data.code + ')' : '');
        }
      },
      {
        headerName: "QA 승인자",
        field: "qa_charger",
        width : 100,
        maxWidth : 120,
        sortable: true,
        filter: "agTextColumnFilter",
        cellClass: "text-center",
        filterParams: {
            filterOptions: easyFilter
        }
      },
      {
        headerName: "내용",
        field: "desc",
        minWidth : 200,
        filter: "agTextColumnFilter",
        cellClass: "ml-2",
        filterParams: {
            filterOptions: easyFilter
        },
        cellRenderer : (param) => {
            return param.value.replace(/\n/g, " ");;
        }
    },
];

const onGridReady = params => {
    params.api.sizeColumnsToFit();
}

const AppVersionLogTable = ({appId, list, dataCallback}) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const [appVersionModalShow, setVersionModalShow] = useState(false);

    useEffect(() => {
        return () => {};
    }, [appId, list]);


    const rowClick = (agGrid) => {
        setSelectedRow(agGrid.api.selectionController.lastSelectedNode.data);
        setVersionModalShow(true);
    }

    return (
        <div className="ag-theme-alpine" style={{height: "490px"}}>
            <AgGridReact
              style={{
                overflowX : "scroll",
                overflowY : "auto" 
              }}
              defaultColDef={{resizable: true }}
              onGridReady={onGridReady}
              columnDefs={listColumn}
              rowData={list}
              rowSelection="single"
              onSelectionChanged={rowClick.bind(this)}
            >
            </AgGridReact>

            <AppVersionLogUpdateForm
                logId={selectedRow ? selectedRow.id : null}
                appId={appId}
                show={appVersionModalShow}
                onHide={()=> {
                    setVersionModalShow(false);
                }}
                dataCallback={(appId)=> {
                    dataCallback(appId);
                }}
            />
        </div>
    );
}

export default AppVersionLogTable;